import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import c from 'classnames';
import ReactPlayer from 'react-player';

import {
  Container,
  WysiwygField,
  Image,
  Lottie,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ButtonWrapper,
} from '../../../../components';

import lottieLandingPageHeroWithVideoLeft from '../../../../assets/lotties/landing-page-hero-left/data.json';
import lottieLandingPageHeroWithVideoRight from '../../../../assets/lotties/landing-page-hero-right/data.json';

import './style.scss';

const LandingPageHeroWithVideo = ({ title, videoUrl, body, preview }) => {
  const [ButtonClicked, setButtonClicked] = useState(false);
  const { t } = useTranslation();

  if (!videoUrl) {
    return null;
  }

  const LandingPageHeroWithVideoWrapperClasses = c('LandingPageHeroWithVideo', {
    'LandingPageHeroWithVideo--button_clicked': ButtonClicked,
  });

  return (
    <Container className={LandingPageHeroWithVideoWrapperClasses}>
      <div className="row">
        <div className="col-12">
          <div className="LandingPage__hero">
            <div className="LandingPageHeroWithVideo__hero">
              <div className="LandingPageHeroWithVideo__title__wrapper">
                <h1 className="LandingPageHeroWithVideo__title">{title}</h1>
                <ButtonWrapper type="primary" onClick={() => { setButtonClicked(true); }}>
                  {t('button.watch_video')}
                  <i className="icon icon-play" />
                </ButtonWrapper>
              </div>

              <div className="LandingPageHeroWithVideo__lottie__wrapper">
                <Lottie
                  className="Lottie__landing_page--left"
                  id="Lottie__landing_page--left"
                  data={lottieLandingPageHeroWithVideoLeft}
                  rendererSettings={{ preserveAspectRatio: 'none' }}
                />
                <div className="LandingPageHeroWithVideo__hero__image_wrapper">
                  <Image
                    lazyload={false}
                    className="LandingPageHeroWithVideo__hero__hero"
                    src={preview}
                  />
                </div>
                <ReactPlayer url={videoUrl} controls playing={ButtonClicked} width="100%" height="100%" />
                <Lottie
                  className="Lottie__landing_page--right"
                  id="Lottie__landing_page--right"
                  data={lottieLandingPageHeroWithVideoRight}
                  rendererSettings={{ preserveAspectRatio: 'none' }}
                />
              </div>

            </div>
          </div>

        </div>
      </div>
      <div className="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2">
        <div className="LandingPage__body__wrapper">
          <WysiwygField
            property="schema:text"
            className="LandingPage__body"
            html={body}
          />
        </div>
      </div>
    </Container>
  );
};

export default LandingPageHeroWithVideo;
